import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const DownloadIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10M7.95519 1.375V9.625M7.95519 9.625L12.1813 5.39916M7.95519 9.625L3.80627 5.476"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
